import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { LINKS, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
export function EmergencyBand() {
  return <section aria-labelledby="emergency-heading" className="w-full bg-kosin-red" data-id="element-32" data-mp="3bz13c2ffj5y0">
      <div className="mx-auto flex max-w-shell flex-col gap-6 px-[18px] py-9 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:py-10" data-id="element-33" data-mp="3qrul5ui6by5u">
        <div className="max-w-[640px]" data-id="element-34" data-mp="2y0kotpbbsb5b">
          <h2 id="emergency-heading" className="text-[24px] font-bold leading-tight text-white lg:text-[30px]" data-id="element-35" data-mp="2y1m98ke8e9zp">
            Broken windshield or car window today?
          </h2>
          <p className="mt-2.5 text-[16px] leading-relaxed text-white/90" data-id="element-36" data-mp="37x76y6c9oo3n">
            Call to check the fastest available opening. Same-day service
            depends on your vehicle, glass availability and schedule.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center lg:shrink-0" data-id="element-37" data-mp="iahr3wtkmpqp">
          <a href={PHONE_HREF} className="focus-light inline-flex items-center justify-center gap-2 rounded bg-white px-6 py-3.5 text-[16px] font-semibold text-kosin-charcoal hover:bg-kosin-mist transition-colors duration-150 ease-kosin" data-id="element-38" data-mp="3tflwvv9eh5vs">
            <PhoneIcon className="h-4 w-4 text-kosin-red" aria-hidden="true" data-id="element-39" data-mp="76azk3drovse" />
            Call {PHONE_DISPLAY}
          </a>
          <a href={LINKS.emergencyAuto} className="focus-light inline-flex items-center justify-center gap-1.5 text-[16px] font-semibold text-white underline decoration-white/50 underline-offset-4 hover:decoration-white transition-colors duration-150 ease-kosin" data-id="element-40" data-mp="3ap463w84okd2">
            Emergency auto glass
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="3oh2da1ia466l" />
          </a>
        </div>
      </div>
    </section>;
}